import { createElement } from "@wordpress/element";

/**
 * External dependencies
 */
import classnames from 'classnames';
/**
 * WordPress dependencies
 */

import { forwardRef } from '@wordpress/element';
/**
 * Internal dependencies
 */

import PanelHeader from './header';

function Panel(_ref, ref) {
  let {
    header,
    className,
    children
  } = _ref;
  const classNames = classnames(className, 'components-panel');
  return createElement("div", {
    className: classNames,
    ref: ref
  }, header && createElement(PanelHeader, {
    label: header
  }), children);
}

export default forwardRef(Panel);
//# sourceMappingURL=index.js.map